import { MessageSquare, X } from "lucide-react"
import { readableTextColor } from "../utils"

export default function ChatTrigger({ style, open, setOpen, triggerRef, brand_color, button_type }: { style?: React.CSSProperties, open: boolean, setOpen: Function, triggerRef: React.RefObject<HTMLButtonElement | null>, brand_color?: string, button_type?: string }) {

    return (
        <button ref={triggerRef} type="button" style={{ ...(brand_color ? { color: readableTextColor(brand_color) } : {}), ...style, backgroundColor: brand_color || style?.backgroundColor }}
            aria-label={open ? "Close chat" : "Open chat"}
            aria-expanded={open}
            aria-haspopup="dialog"
            onClick={() => { setOpen(!open) }}
            onKeyDown={(e) => {
                if (e.key === "Escape" && open) setOpen(false)
            }}
            onMouseDown={(e) => {
                e.preventDefault()
            }}
            className={"cl-trigger " + (button_type === "icon_text" ? "cl-trigger-text" : "")}>
            <X aria-hidden="true" className={"cl-trigger-icon " + (open ? "cl-scale-100" : "cl-scale-0")} />
            <div className={"cl-trigger-content " + (open ? "cl-scale-0" : "cl-scale-100")}>
                <MessageSquare aria-hidden="true" className="cl-trigger-icon-static" />
                {button_type === "icon_text" && <span className="cl-trigger-span">Help</span>}
            </div>
        </button>
    )
}
